/**
 * @desc 列表
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.LogisticsProviderResponseDto>>;
export function request(
  params: API.tms.logisticsProvider.list.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsProvider/list`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
